import { ZENIFY_ERROR_MAP } from "src/constants/constants";

export function getZenifyErrorMessage(data) {
  const code = String(data?.errorCode || "").trim();

  if (!code) return null;

  return ZENIFY_ERROR_MAP[code] || null;
}
